var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lightUgTable"},[_c('div',{ref:"lightUgTableHead",staticClass:"lightUgTable__head",style:({ top: _vm.stickyTop })},[_vm._t("header")],2),_c('div',{staticClass:"lightUgTable__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }